import { parseQrContext } from "../utils/qrContext";
import type { TableType } from "../Types/tabletype";
import { withCache } from "./apiCacheHelper.ts";
import apiClient from "./apiClient.ts";

export const getTable = async (id: string | number): Promise<TableType> => {
  const context = parseQrContext(id);
  if (!context) throw new Error("Invalid QR code. Please scan a table or branch QR.");
  const tableId = encodeURIComponent(context.qrId);

  return withCache(`table_${tableId}`, async () => {
    try {
      const res = await apiClient.get<TableType>(`/${context.type}/find/${tableId}`);
      return res.data;

    } catch (error) {
      console.error("Table API Error:", error);
      throw error;
    }
  });
};
